
/* @ngInject */
class AuthenticationFactory {
    constructor(HPConfig, localStorageService, $interval) {
        this.HPConfig = HPConfig;
        this.localStorageService = localStorageService;
        this.$interval = $interval;

        this.authDataStorageKey = 'authorizationData';
        this.expiresInSeconds = this.HPConfig.tokenExpirationInSeconds; // seconds
        this.authDataIntervalDelay = 1; // seconds
        this.authDataInterval = null;


        this.startAuthDataInterval();
    }

    getAuthenticationData() {
        // set expiration for storage
        let expiresIn = this.localStorageService.get(`${this.authDataStorageKey}_expiresIn`);
        expiresIn = (expiresIn === undefined || expiresIn === null) ? expiresIn = 0 : expiresIn;

        if (expiresIn < Date.now()) { // Expired
            this.localStorageService.remove(this.authDataStorageKey);
            return null;
        }
        try {
            return this.localStorageService.get(this.authDataStorageKey);
        } catch (e) {
            console.log(`getStorage: Error reading token from localStorage: ${JSON.stringify(e)}`);
            return null;
        }
    }

    removeAuthenticationData() {
        try {
            this.localStorageService.remove(this.authDataStorageKey);
            this.localStorageService.remove(`${this.authDataStorageKey}_expiresIn`);
        } catch (e) {
            console.log(`removeStorage: Error removing token localStorage: ${JSON.stringify(e)}`);
            return false;
        }
        return true;
    }

    stopAuthenticationInterval(expiration) {
    // Stop interval for 40 minutes(by default), so user doesn't get logged out when docusign
        if (expiration === undefined) {
            expiration = 60 * 40; // 40 minutes
        }
        this.stopAuthDataInterval();
        const schedule = Date.now() + expiration * 1000;
        this.localStorageService.set(`${this.authDataStorageKey}_expiresIn`, schedule);
    }

    setAuthenticationData(authData) {
        this.stopAuthDataInterval();

        const schedule = Date.now() + this.expiresInSeconds * 1000;
        try {
            this.localStorageService.set(this.authDataStorageKey, authData);
            this.localStorageService.set(`${this.authDataStorageKey}_expiresIn`, schedule);
            this.startAuthDataInterval();
        } catch (e) {
            console.log(`setStorage: Error setting token on localStorage: ${JSON.stringify(e)}`);
            return false;
        }
        return true;
    }

    startAuthDataInterval() {
    // start interval to keep the token alive
        this.authDataInterval = this.$interval(() => {
            if (this.localStorageService.get(`${this.authDataStorageKey}_expiresIn`) !== undefined) {
                const newSchedule = Date.now() + this.expiresInSeconds * 1000;
                this.localStorageService.set(`${this.authDataStorageKey}_expiresIn`, newSchedule);
            }
        }, this.authDataIntervalDelay * 1000, 0, false);
    }

    stopAuthDataInterval() {
    // stop the interval;
        if (this.authDataInterval !== undefined) {
            this.$interval.cancel(this.authDataInterval);
        }
    }
}

export default ['HPConfig', 'localStorageService', '$interval', AuthenticationFactory];



// WEBPACK FOOTER //
// ./src/app/common/userAuthorization/authentication.factory.js